// Global
import React from 'react';
import clsx from 'clsx';

// Local
import { Accordion as HelperAccordion } from 'components/helpers/Accordion/Accordion';
import { AccordionItemData } from 'components/helpers/Accordion/AccordionContext';
import { Preamble, PreambleProps } from 'components/helpers/Molecules/Preamble/Preamble';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { Themes } from 'lib/themes';
import styles from './Accordion.module.scss';

export interface AccordionProps {
  className?: string;
  preambleFields?: PreambleProps;
  accordionItems: AccordionItemData[];
  noImagesLayout?: boolean;
  theme?: Themes;
}

export const Accordion = ({
  className,
  preambleFields,
  accordionItems,
  noImagesLayout,
  theme,
}: AccordionProps) => {
  // Render wrapper with preamble even if no accordion items (for editing mode)
  const hasItems = accordionItems && accordionItems.length > 0;
  const accordionId = React.useId();
  const accordionHeadingId = preambleFields?.headline ? `accordion-${accordionId}` : null;

  return (
    <BrandAndThemeProvider theme={theme}>
      <div className={clsx(styles.accordionSectionWrapper, className)}>
        <div className={styles.accordionWrapper}>
          {preambleFields && <Preamble {...preambleFields} headingId={accordionHeadingId} />}
          {hasItems && (
            <HelperAccordion
              accordionItems={accordionItems}
              singleOpenPanel={true}
              scrollToOpenPanel={true}
              openByDefault={false}
              ariaLabelledBy={accordionHeadingId}
              className={styles.accordionSection}
              containerClassName={clsx(
                styles.accordionContainer,
                noImagesLayout && styles.noImagesLayout
              )}
              itemClassName={styles.accordionItem}
              contentClassName={styles.accordionContent}
            />
          )}
        </div>
      </div>
    </BrandAndThemeProvider>
  );
};
